import { z } from 'zod';
/**
 * Bank export feature (2026-06-09) — shared shapes.
 *
 * Two concerns live here:
 *   1. The tenant's employer **bank profile** (self-documentation; persisted in
 *      OrganizationBankProfile). Does NOT affect file generation.
 *   2. The **bank export** row + coverage-error shapes used by the generic CSV
 *      generator (built from per-Employee bank fields, not the profile).
 */
// ---------------------------------------------------------------------------
// Employer bank profile (self-documentation)
// ---------------------------------------------------------------------------
/** A single employer bank account the tenant declares. Documentation only. */
export const EmployerBankAccount = z.object({
    bankName: z.string().trim().min(1).max(200),
    accountNumber: z.string().trim().min(1).max(34),
    accountName: z.string().trim().min(1).max(200),
    currency: z.string().trim().length(3), // ISO 4217 (USD, CDF, NGN, GHS)
    purpose: z.string().trim().max(200).optional(), // e.g. "Salary disbursement"
});
/** PUT body for the tenant bank profile. `accounts` is capped for sanity. */
export const OrganizationBankProfileInput = z.object({
    accounts: z.array(EmployerBankAccount).max(20),
    narrationTemplate: z.string().trim().max(200).nullable().optional(),
});
//# sourceMappingURL=bankExport.js.map